import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { UseScreen } from '../../hooks/UseScreen.hook';

const CreateReservation = () => {

    const screenWidth = UseScreen();

  return (
    <>
        <Grid item xs={ 12 } md={6} sx={ (screenWidth > 500) ? { mt: 4 } : {} }>
            <h5 style={{ margin: '0' }}>Crear reserva</h5>
            <p style={{ margin: '0' }}>02/07/2022 - 08/07/2022</p>
        </Grid>
        <Grid item xs={ 12 } md={6} sx={{ mt: 4 }}>
            <PrimaryLightInput
                label="Buscar cliente"
                fullWidth
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                    ),
                }}
            />
        </Grid>
        <Grid item xs={ 12 } sx={ ( screenWidth > 500 ) ? { mt: 4 } : {} }>
            <p>Huésped</p>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container>
            <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                    <PrimaryLightSelect 
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Tipo de documento"
                    >
                        <MenuItem value='passport'>Pasaporte</MenuItem>
                        <MenuItem value="v">V-</MenuItem>
                        <MenuItem value="e">E-</MenuItem>
                        {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                    </PrimaryLightSelect>
                </FormControl>
            </Grid>
            <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <PrimaryLightInput
                    label="Nº de documento"
                    fullWidth
                />
            </Grid>
            <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <PrimaryLightInput
                    label="Nombre"
                    fullWidth
                />
            </Grid>
            <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <PrimaryLightInput
                    label="Apellido"
                    fullWidth
                />
            </Grid>
            <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <PrimaryLightInput
                    label="E-mail"
                    fullWidth
                />
            </Grid>
            </Grid>
        </Grid>
        {
            ( screenWidth > 500 ) &&
                <Grid item xs={ 12 } sx={{ mt: 2 }}>
                    <p>Habitación</p>
                </Grid>
        }
        <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo de Habitación</InputLabel>
                    <PrimaryLightSelect 
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    >
                        <MenuItem value='double-bed'>Matrimonial</MenuItem>
                        <MenuItem value='personal'>Personal</MenuItem>
                        <MenuItem value='double'>Doble</MenuItem>
                        <MenuItem value='junior-suite'>Junior Suite</MenuItem>
                        <MenuItem value='suite'>Suite</MenuItem>
                    </PrimaryLightSelect>
                </FormControl>
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 0 }} textAlign='end' className='pr-2'>
            <PrimaryOutlinedButton onClick={ () => alert('Form one') }>Crear reserva</PrimaryOutlinedButton>
        </Grid>
    </>
  )
}

export default CreateReservation